import { Header2, Text } from '@ardoq/typography';
import { DrawerHeaderProps } from './types';
import { FlexBox, Stack } from '@ardoq/layout';

export const DrawerHeader = ({
  title,
  icon,
  subtitle,
  controls,
}: DrawerHeaderProps) => {
  return (
    <FlexBox
      justify="space-between"
      paddingTop="large"
      paddingX="large"
      align={'center'}
      data-drawer-header
    >
      <Stack gap="small">
        <FlexBox gap="small">
          {icon}
          <Header2>{title}</Header2>
        </FlexBox>
        {subtitle && (
          <Text variant="text2" color="textSubtle">
            {subtitle}
          </Text>
        )}
      </Stack>
      <FlexBox gap="small" align="center">
        {controls}
      </FlexBox>
    </FlexBox>
  );
};
